import React from 'react';
import { connect } from 'react-redux';
import { changeCode, REDUCER_NAME } from '../reducer';
import SearchBox from '../../../../../component/common/search-box/SearchBox';
import PriceInfo from './PriceInfo';

class IndexSummary extends React.Component {
  render() {
    const { currentSearch, changeCode } = this.props;
    return (
      <div className="left-info-widget">
        <SearchBox changeCode={changeCode} currentSearch={currentSearch} />
        <PriceInfo />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentSearch: state[REDUCER_NAME].currentSearch,
});

const mapDispatchToProps = {
  changeCode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndexSummary);
